module.exports = __webpack_public_path__ + "img/interpack-active.f1de33ee.svg";